import { configureStore } from '@reduxjs/toolkit';
import userReducer from './user_SliceReducer';
import yourMetricsReducer from './yourMetrics_SliceReducer';
import excerciseReducer from './excercise_SliceReducer';

export default configureStore({
    reducer: {
        user: userReducer,
        yourMetrics: yourMetricsReducer,
        currentExercise:excerciseReducer
    },
})